import { useQuery } from "react-query";
import Select from "react-select"

import { getCompanies } from "../../../../../MyApi/hr/companies";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addCurrency.module.css";

const EditSalary = ({
  salaryName, amount, type , amount_Type,   setSalaryName , setAmount, companyId,setCompanyId,setAmount_type ,setDescription,description,setActive ,active ,setType
  
}) => {
const {data , isLoading} = useQuery("getComapines" , getCompanies)

  const DescriptionIcon = icons.description
  const LevelIcon = icons.levels
  const DollarSign = icons.Dollar;
  const Company = icons.company
  


  const handleNameChange = (e) => {
    const {value}=e.target;
    setSalaryName(value);
  };
  const handleSelectedIdChange = (selectedCompany) => {
    const companyId = selectedCompany ? selectedCompany.id :0
    setCompanyId(companyId);
   
    
  }; 
  const handleDescChange =(e)=>{
    const {value} =e.target ;
  setDescription(value)
  }
  const handleAmountChange =(e)=>{
    const {value} = e.target;
    const doubleAmount = parseFloat(value).toFixed(3)
    setAmount(value)
  }
  const handleType =(e)=>{
    const {value}= e.target;
    setType(value)
  }
  const handleAmountType =(e)=>{
    const {value} =e.target ;
    setAmount_type(value)
  }
  const handleActiveChange = (e)=>{
    const isChecked = e.target.checked
 setActive(isChecked ?1:0)

  }

  if(isLoading){
    return <LoadingSpinner/>
  }
  const compaines =data?.data || []
  const defaultCompany = compaines.find(option=>option.id  === companyId) 
  const amountType = ["percent" ,"fixed"]
  const typeArr =["undeserved" , "deserved"]
  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">الاسم </label>
          <div className={classes.iconInput}>
            <LevelIcon />
          </div>
          <input
            type="text"
            placeholder="ادخل  الاسم"
            onChange={handleNameChange}
            value={salaryName}
            className={classes.inputCustom}
          />
              
        </div>
         <div className={classes.formCol}>
          <label htmlFor="">الوصف </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <textarea  
            type="textarea"
            placeholder="ادخل  الوصف"
            onChange={handleDescChange}
            value={description}
            className={classes.inputCustom}
          > </textarea> 
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">الكمية </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <input  
            type="number"
            placeholder="ادخل  الكمية"
          
            onChange={handleAmountChange}
            value={amount}
            className={classes.inputCustom}
         />  
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">النوع </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <select  
            onChange={handleType}
            value={type}
            className={classes.inputCustom}
         > 
         <option value="">اختار النوع</option>
        { typeArr.map((type , i)=>(
          <option value={type} key={i}> {type}</option>
        ))}
          </select>
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">نوع الكمية   </label>
          <div className={classes.iconInput}>
            <DescriptionIcon />
          </div>
          <select  
            onChange={handleAmountType}
            value={amount_Type}
            className={classes.inputCustom}
          > 
          <option value="">اختار نوع الكمية</option>
          {amountType.map((amountype ,i)=>(
            <option key={i} value={amountype} >{amountype}</option>
          ))}
          </select>
        </div>

        
          {!data ? <div>no data available </div> :  
        <div className={classes.formCol}>
          <label htmlFor=""> الشركة</label>
          <Select
            type="text"
            value={defaultCompany}
            options={compaines}
            getOptionValue={(e)=>e.id}
            getOptionLabel={(e)=>e.name}
            placeholder="اختار الشركة  "
            onChange={handleSelectedIdChange}
            
          />
        
      
        </div> }
    
   
        
          <div className={classes.formCol}> 
           <label htmlFor="" className={active ? `${classes.active}` : `${classes.disActive}`}> {active==1 ?" نشط":"غير نشط"} </label>
         
          <label class="switch">
           <input type="checkbox" onChange={handleActiveChange} checked={active}/>
             <span class="slider round"></span>
         </label>   
        </div>
   
      
     
      </div>
    </div>
  );
};

export default EditSalary;
